<script>
export default {
  computed: {
    fabStyle() {
      return "bottom: 30px";
    }
  }
};
</script>
